function initHeroVideo(sectionId) {
  const heroWrapper = document.getElementById('hero-wrapper-' + sectionId);
  const heroIntro = document.getElementById('hero-intro-' + sectionId);
  const heroVideoSection = document.getElementById('hero-video-section-' + sectionId);
  const heroContent = document.getElementById('hero-content-' + sectionId);
  const videoOverlay = document.getElementById('video-overlay-' + sectionId);
  const videoElement = document.getElementById('hero-video-' + sectionId);
  
  if (!heroWrapper || !heroIntro || !heroVideoSection || !heroContent || !videoOverlay) return;
  
  let lastScrollY = window.scrollY;
  let scrollDirection = 'down';
  let videoPlayed = false;
  let fadeOutTimer = null;
  let hasReachedVideoCenter = false;
  let minScale = 100; // 跟踪最小缩放比例
  
  // 使用 Intersection Observer 检测 hero-video-wrapper 是否在可视范围内
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 进入可视范围，设置为 flex
        heroContent.style.display = 'flex';
      } else {
        // 离开可视范围，设置为 none
        heroContent.style.display = 'none';
      }
    });
  }, {
    threshold: 0.4, // 只要有一点进入视口就触发
    rootMargin: '0px' // 无边距
  });
  
  // 开始观察 hero-wrapper
  observer.observe(heroWrapper);
  
  // 添加点击视频暂停/继续播放功能
  if (videoElement) {
    heroVideoSection.addEventListener('click', function() {
      if (videoElement.paused) {
        videoElement.play().catch(function(error) {
          console.log('Video play failed:', error);
        });
      } else {
        videoElement.pause();
      }
    });
    
    // 确保视频初始状态为暂停
    videoElement.pause();
    videoElement.currentTime = 0;
  }
  
  function checkScroll() {
    const currentScrollY = window.scrollY;
    const introRect = heroIntro.getBoundingClientRect();
    const videoRect = heroVideoSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // 检测滚动方向
    if (currentScrollY > lastScrollY) {
      scrollDirection = 'down';
    } else if (currentScrollY < lastScrollY) {
      scrollDirection = 'up';
    }
    lastScrollY = currentScrollY;
    
    // 向下滚动逻辑
    if (scrollDirection === 'down') {
      // 当hero-intro全部显示时，logo和文案开始显示
      if (introRect.top <= 0 && introRect.bottom >= 0) {
        heroContent.classList.add('visible');
        heroContent.classList.remove('fade-out');
      }
      
      // 计算从intro到video的滚动进度
      if (introRect.bottom <= windowHeight) {
        const scrolled = Math.max(0, -introRect.top);
        const progress = Math.min(1, scrolled / heroIntro.offsetHeight);
        
        // 缩放从100%到50%，向下移动
        const scale = 100 - (progress * 30);
        const translateY = progress * 100;
        
        heroContent.style.transform = `translate(-50%, calc(-50% + ${translateY}px)) scale(${scale / 100})`;
        
        // 当到达视频中间位置时，逐渐消失
        if (videoRect.top <= windowHeight / 2 && videoRect.bottom >= windowHeight / 2) {
          // 计算在视频中间区域的进度
          const videoCenterProgress = Math.min(1, (windowHeight / 2 - videoRect.top) / (windowHeight * 0.2));
          
          // 逐渐降低opacity
          const opacity = 1 - videoCenterProgress;
          heroContent.style.opacity = opacity;
          
          if (!hasReachedVideoCenter && videoCenterProgress > 0.5) {
            hasReachedVideoCenter = true;
            
            // 清除之前的定时器
            if (fadeOutTimer) {
              clearTimeout(fadeOutTimer);
            }
            
            // 完全消失后移除遮罩层并播放视频
            fadeOutTimer = setTimeout(function() {
              heroContent.classList.add('fade-out');
              videoOverlay.classList.add('hidden');
              
              // 播放视频
              if (videoElement && !videoPlayed) {
                videoElement.muted = false;
                videoPlayed = true;
                videoElement.play().catch(function(error) {
                  console.log('Video autoplay failed:', error);
                  // 如果自动播放失败，尝试静音播放
                  videoElement.muted = true;
                  videoElement.play().catch(function(mutedError) {
                    console.log('Muted autoplay also failed:', mutedError);
                  });
                });
              }
            }, 500);
          }
        }
      }
    } 
    // 向上滚动逻辑
    else if (scrollDirection === 'up') {
      // 清除淡出定时器
      if (fadeOutTimer) {
        clearTimeout(fadeOutTimer);
        fadeOutTimer = null;
      }
      
      // 重置opacity
      heroContent.style.opacity = '';
      
      // 如果滚动到intro区域上方（introRect.top >= introRect的高度），logo和文案消失
      if (introRect.top >= introRect.height) {
        heroContent.classList.remove('visible');
        heroContent.classList.add('fade-out');
        videoOverlay.classList.remove('hidden');
        heroContent.style.transform = 'translate(-50%, -50%) scale(1)';
        hasReachedVideoCenter = false;
        
        // 暂停并重置视频
        if (videoElement && videoPlayed) {
          videoElement.pause();
          videoElement.currentTime = 0;
          videoPlayed = false;
        }
      }
      // 如果回到intro区域内（0 <= top < height）
      else if (introRect.top >= 0 && introRect.top < introRect.height) {
        heroContent.classList.remove('fade-out');
        heroContent.classList.remove('visible');
        videoOverlay.classList.remove('hidden');
        heroContent.style.transform = 'translate(-50%, -50%) scale(1)';
        hasReachedVideoCenter = false;
        
        // 暂停并重置视频
        if (videoElement && videoPlayed) {
          videoElement.pause();
          videoElement.currentTime = 0;
          videoPlayed = false;
        }
      }
      // 如果在intro和video之间向上滚动
      else if (introRect.bottom > 0 && videoRect.top > 0) {
        // 重新计算位置
        const scrolled = Math.max(0, -introRect.top);
        const progress = Math.min(1, scrolled / heroIntro.offsetHeight);
        const scale = 100 - (progress * 30);
        const translateY = progress * 100;
        
        heroContent.style.transform = `translate(-50%, calc(-50% + ${translateY}px)) scale(${scale / 100})`;
        heroContent.classList.add('visible');
        heroContent.classList.remove('fade-out');
        
        // 显示遮罩层
        videoOverlay.classList.remove('hidden');
        hasReachedVideoCenter = false;
        
        // 暂停视频
        if (videoElement && videoPlayed) {
          videoElement.pause();
          videoPlayed = false;
        }
      }
      // 如果在视频区域向上滚动
      else if (videoRect.top <= 0) {
        // 保持视频播放，不显示遮罩层
        videoOverlay.classList.add('hidden');
        heroContent.classList.add('fade-out');
        
        // 继续播放视频
        if (videoElement && !videoPlayed) {
          videoElement.muted = false;
          videoPlayed = true;
          videoElement.play().catch(function(error) {
            console.log('Video autoplay failed:', error);
            // 如果自动播放失败，尝试静音播放
            videoElement.muted = true;
            videoElement.play().catch(function(mutedError) {
              console.log('Muted autoplay also failed:', mutedError);
            });
          });
        }
      }
    }
  }
  
  // 监听滚动事件
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        checkScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  // 初始检查
  checkScroll();
}
